import {
  GETDASHBOARDDATE,
  GETMENU,
  GETMENUASSOCIATE,
  GETMENUHEADER,
  GETUSER,
  ITEMCATEGORY,
  ITEMGET,
  UPDATEBILL,
} from "./api";
import axios from "./axios";

export const GetUserApi = async () => {
  const res = await axios.get(GETUSER);
  return res;
};

export const GetUserMenuApi = async (businessLineId, languageCode) => {
  const res = await axios.get(GETMENU + businessLineId + "/" + languageCode);
  return res;
};

export const GetUserMenuHeaderApi = async (businessLineId, languageCode) => {
  const res = await axios.get(
    GETMENUHEADER + businessLineId + "/" + languageCode,
  );
  return res;
};
export const GetUserMenuAssociate = async (businessLineId, languageCode) => {
  const res = await axios.get(GETMENUASSOCIATE);
  return res;
};
export const ItemCategoryApi = async (params) => {
  const res = await axios.post(ITEMCATEGORY, params);

  return res;
};
export const ItemGETApi = async (params) => {
  const res = await axios.post(ITEMGET, params);
  return res;
};

export const getdashBoardApi = async () => {
  const res = await axios.get(GETDASHBOARDDATE);
  return res;
};

export const useBreakpoint = (useTheme, useMediaQuery) => {
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));

  if (isXl) return "xl";
  if (isLg) return "lg";
  if (isMd) return "md";
  if (isSm) return "sm";
  if (isXs) return "xs";

  return "xs"; // fallback
};
